import { render, staticRenderFns } from "./ConfigLanguageSelector.vue?vue&type=template&id=8313a5dc&"
import script from "./ConfigLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./ConfigLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports